import * as sensorApi from './sensors';
import * as farmApi from './farm';
import * as userApi from './user';
import * as controlApi from './control';
import * as plansApi from './plans';
import * as blockApi from './block';
import * as satelliteApi from './satellite';
import * as recommendationApi from './recommendation';
import * as scheduleApi from './schedule';
import * as reportsApi from './reports';

export default {
  farmApi,
  userApi,
  sensorApi,
  controlApi,
  plansApi,
  blockApi,
  satelliteApi,
  recommendationApi,
  scheduleApi,
  reportsApi,
};
